import { Alert, Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, MenuItem, TextField, Typography } from '@mui/material';
import React from 'react';

import { CopyWeekFormErrors, CopyWeekFormValues, ProgramWeekOption } from './programs.types';

interface Props {
    errors: CopyWeekFormErrors;
    onCancel: () => void;
    onConfirm: () => void;
    onFieldChange: (name: keyof CopyWeekFormValues, value: string | boolean) => void;
    sourceConfiguredDays: number;
    targetConfiguredDays: number;
    values: CopyWeekFormValues;
    visible: boolean;
    weekOptions: ProgramWeekOption[];
}

const CopyWeekDialog: React.FC<Props> = ({ errors, onCancel, onConfirm, onFieldChange, sourceConfiguredDays, targetConfiguredDays, values, visible, weekOptions }) => (
    <Dialog fullWidth maxWidth="sm" open={visible}>
        <DialogTitle>Copy Week</DialogTitle>
        <DialogContent dividers sx={{ display: 'grid', gap: 2.25 }}>
            <TextField
                fullWidth
                helperText={errors.sourceWeek}
                label="Source Week"
                onChange={(event) => onFieldChange('sourceWeek', event.target.value)}
                select
                size="small"
                value={values.sourceWeek}
            >
                {weekOptions.map((option) => (
                    <MenuItem key={option.value} value={String(option.value)}>{option.label}</MenuItem>
                ))}
            </TextField>
            <TextField
                error={Boolean(errors.targetWeek)}
                fullWidth
                helperText={errors.targetWeek}
                label="Target Week"
                onChange={(event) => onFieldChange('targetWeek', event.target.value)}
                size="small"
                value={values.targetWeek}
            />
            <FormControlLabel
                control={<Checkbox checked={values.overwriteExisting} onChange={(event) => onFieldChange('overwriteExisting', event.target.checked)} />}
                label="Overwrite target week if it already has data"
            />
            <Box sx={{ display: 'grid', gap: 0.75 }}>
                <Typography sx={{ fontWeight: 700 }} variant="subtitle2">Target Status</Typography>
                <Typography color="text.secondary" variant="body2">
                    {targetConfiguredDays > 0 ? `Week ${values.targetWeek} currently has ${targetConfiguredDays} configured day entries.` : `Week ${values.targetWeek} is currently empty.`}
                </Typography>
            </Box>
            <Box sx={{ display: 'grid', gap: 0.75 }}>
                <Typography sx={{ fontWeight: 700 }} variant="subtitle2">Copy Preview</Typography>
                <Typography color="text.secondary" variant="body2">- {sourceConfiguredDays} configured day entries will be copied</Typography>
                <Typography color="text.secondary" variant="body2">- This change will stay in draft until saved</Typography>
                {targetConfiguredDays > 0 && <Typography color="text.secondary" variant="body2">- Existing target week entries will be replaced if overwrite is enabled</Typography>}
            </Box>
            {errors.overwriteExisting && <Alert severity="warning">{errors.overwriteExisting}</Alert>}
        </DialogContent>
        <DialogActions sx={{ px: 3, py: 2 }}>
            <Button onClick={onCancel}>Cancel</Button>
            <Button onClick={onConfirm} variant="contained">Copy Into Draft</Button>
        </DialogActions>
    </Dialog>
);

export default CopyWeekDialog;